'use client'

import Link from 'next/link'

// Components
import { Icons } from '@/components/shared/icons'
import { MainNav } from '@/components/layout/header/main-nav'
import { MobileNav } from '@/components/layout/header/mobile-nav'
import LocaleSwitcher from '@/components/layout/header/locale-switcher'
import BlurImage from '@/components/shared/blur-image'

// Utils
import useScrollDirection from '@/hooks/use-scroll-direction'

// Config
import { siteConfig } from '@/config/site'
import { cn, placeholderBlurhash } from '@/lib/utils'

// Types
import type { Locale } from '@/i18n-config'

export function SiteHeader({ lang }: { lang: Locale }) {
  const { scrollDirection, lastScrollY } = useScrollDirection()
  return (
    <header
      className={cn(
        'fixed inset-x-0 z-50 mx-auto w-full bg-white shadow backdrop-blur transition-all duration-300 ease-in-out ',
        scrollDirection === 'up' || lastScrollY === 0
          ? 'translate-y-0 '
          : '-translate-y-full'
      )}
    >
      <div className="mx-auto flex max-w-7xl  items-center container px-3">
        <MainNav lang={lang} />
        <MobileNav lang={lang} />

        <div className="flex flex-1 items-center justify-between gap-2 md:hidden">
          <div className="py-2 md:hidden">
            <Link
              href={`/${lang}`}
              className="ml-2 flex cursor-pointer items-center gap-2"
            >
              <BlurImage
                alt={siteConfig.title}
                blurDataURL={placeholderBlurhash}
                width={200}
                height={0}
                priority={true}
                placeholder="blur"
                className="invert"
                src="/assets/images/logo.png"
              />
              {/* <Icons.logo className="size-24" /> */}
              <span className="sr-only">{siteConfig.name} - Home page</span>
              {/* <Icons.logo className="size-6" />
              <span className="inline-block font-satoshi text-lg font-bold">
                {siteConfig.name}
              </span> */}
            </Link>
          </div>
          <LocaleSwitcher />
        </div>
      </div>
    </header>
  )
}
